import React from 'react';
import Spinner from 'react-spinner';
import TransitionGroup from 'react-transition-group/CSSTransitionGroup';

import fetchContent from '../../helpers/backend-communication';
import StatisticsCard from './StatisticsCard';

class Statistics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      statsData: [],
      isLoading: null
    };
  }

  componentDidMount() {
    console.log('Fetching content for statistics....');
    this.setState({
      isLoading: true
    });

    fetchContent('statistics')
      .then(responseObject => {
        const statsData = responseObject ? Object.values(responseObject) : [];
        this.setState({
          isLoading: false,
          statsData: statsData
        });
      })
  }

  renderSections() {
    const { statsData } = this.state;
    if (statsData.length < 1) return null;

    return statsData.map((section, index) => {
      const sectionNb = index + 1,
        questions = section.questions,
        highlighted = section.is_highlighted && section.is_highlighted[0];

      if (!questions || Object.keys(questions).length === 0) return null;

      return (
        <div key={ index } className="col-md-4">
          <StatisticsCard
            title={ section.header }
            sectionId={ 'section-' + sectionNb }
            questions={ questions }
            highlighted={ highlighted }
          />
        </div>
      );
    });
  }

  render() {
    const isLoading = this.state.isLoading;

    if (isLoading) return <Spinner />;

    return (
      <TransitionGroup
        transitionName="ajax"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}
      >
        { this.renderSections() }
      </TransitionGroup>
    );
  }
}

export default Statistics;



// WEBPACK FOOTER //
// ./src/components/Statistics/Statistics.js